import React from "react";

function PodcastCard() {
  const handlePlay = () => {
    window.open(
      "https://podscan.fm/podcasts/gsd-venture-studios-podcasts-by-gary-fowler-1/episodes/baas-amp-digital-assets-the-new-rules-of-global-finance-with-massimo-barone",
      "_blank"
    );
  };

  return (
    <div style={styles.card}>
      
      {/* Image */}
      <div style={styles.imageContainer}>
        <img
          src="https://d3t3ozftmdmh3i.cloudfront.net/staging/podcast_uploaded_nologo/7732301/7732301-1748680291394-a6942fdcce445.jpg"
          alt="Podcast Cover"
          style={styles.image}
        />

        {/* Play Button Overlay */}
        <button style={styles.playBtn} onClick={handlePlay}>
          ▶
        </button>
      </div>

      {/* Content */}
      <div style={{ padding: "15px" }}>
        <h4>BaaS & Digital Assets</h4>
        <p style={{ color: "#666" }}>
          The New Rules of Global Finance
        </p>
      </div>

    </div>
  );
}

const styles = {
  card: {
    width: "300px",
    borderRadius: "15px",
    overflow: "hidden",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    background: "#fff",
  },
  imageContainer: {
    position: "relative",
  },
  image: {
    width: "100%",
    height: "200px",
    objectFit: "cover",
  },
  playBtn: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    background: "rgba(0,0,0,0.7)",
    color: "#fff",
    border: "none",
    borderRadius: "50%",
    width: "60px",
    height: "60px",
    fontSize: "20px",
    cursor: "pointer",
  },
};

export default PodcastCard;